import React, { useCallback, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { NumberFilter } from '../filters/NumberFilter';
import { debounce } from 'lodash';
import TextField from '@mui/material/TextField';
import { NumericFormat } from 'react-number-format';
import { formatNumber } from '../../../reducer/actions/formatNumber';
import { InputAdornment, IconButton } from '@mui/material';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export const SPNumberField: FieldComponent<number, string[]> = ({
  onChange,
  defaultValue,
  forcedValue,
  disabled,
  isMissing,
  column,
  columnName,
                                                                  withOutEndAdornment,
}) => {
  const [currentState, setCurrentState] = useState<any>({
    value: undefined,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({
        value: defaultValue,
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {

    if (forcedValue) {
      setCurrentState({
        value: forcedValue,
        send: false,
      });
    }
  }, [forcedValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  const increment = (prevValue: any) => {
    handleChange((prevValue || 0) + 1);
  };

  const decrement = (prevValue: any) => {
    handleChange((prevValue || 0) - 1);
  };

  return (
    <>
      <NumericFormat
        value={currentState.value}
        className={'w-full'}
        thousandSeparator=" "
        customInput={TextField}
        size="small"
        disabled={disabled}
        variant="outlined"
        InputProps={{
          endAdornment: (withOutEndAdornment?<></>:
            <>
              {column?.name === 'VAT' && (
                <InputAdornment position="end">
                  <PercentRoundedIcon color={'disabled'} fontSize={'small'} />
                </InputAdornment>
              )}
              <InputAdornment position="end">
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <IconButton
                    sx={{
                      p: '0px',
                    }}
                    size="small"
                    onClick={() => increment(currentState.value)}
                    disabled={disabled}
                    aria-label="increment"
                  >
                    <ArrowDropUpIcon
                      sx={{
                        fontSize: '13px',
                      }}
                    />
                  </IconButton>
                  <IconButton
                    sx={{
                      p: '0px',
                    }}
                    size="small"
                    onClick={() => decrement(currentState.value)}
                    disabled={disabled}
                    aria-label="decrement"
                  >
                    <ArrowDropDownIcon
                      sx={{
                        fontSize: '13px',
                      }}
                    />
                  </IconButton>
                </div>
              </InputAdornment>
            </>
          ),
        }}
        sx={{
          '& input': {
            fontSize: '14px',
            textAlign: 'right',
          },
        }}
        onChange={(event) => {
          const value = formatNumber(event.target.value, true);
          handleChange(value);
        }}
        onValueChange={(values) => {
          const { formattedValue, value, floatValue } = values;

          /*console.log('value change');
          console.log(parseFloat(value));

          handleChange(parseFloat(value));*/
        }}
      />
    </>
  );
};

SPNumberField.includes = (query = [], value = NaN) =>
  query.length === 0 ||
  query.some((filter) => {
    const filterValue = parseFloat(filter);
    if (!isNaN(filterValue)) {
      return filterValue === value;
    }
    return false;
  });

SPNumberField.comparator = (one, other) => {
  if (other === undefined) return -1;
  if (one === undefined) return 1;
  return one - other;
};

SPNumberField.FilterRenderer = NumberFilter;
